import React from "react";
import {
  LogoColumn,
  LogoLine,
  LogoName,
  LogoLabel,
  StyledLogo,
} from "./FloatingLogo.styles";

const FloatingLogo: React.FC = () => {
  return (
    <LogoLine to="/">
      <StyledLogo />
      <LogoColumn>
        <LogoName>idt.license</LogoName>
        <LogoLabel>
          Система лицензирования компании
          <br />
          ООО "Интеллект-Развитие-Технологии"
        </LogoLabel>
      </LogoColumn>
    </LogoLine>
  );
};

export default FloatingLogo;
